<template>
  <CreatorSignupHero />
</template>
<script>
import CreatorSignupHero from "../components/Form/CreatorSignupHero1.vue";

export default {
  name: "CreatorSignup",
  components: {
    CreatorSignupHero,
  },
  beforeMount() {
    // Add classes to Navbar
    const hideFooter = false;
    this.$emit("data-hideFooter", hideFooter);
  },

  beforeUnmount() {
    // Remove classes to Navbar
    const hideFooter = false;
    this.$emit("data-hideFooter", hideFooter);
  },
};
</script>
<style lang="scss" scoped></style>
